// React Required
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// i18n (must load before app)
import './i18n';

// Create Import File
import './index.scss';

// Common Layout

import PageScrollTop from './component/PageScrollTop';

// Home layout
import Home from './home/Home';

// Element Layout
import About from "./elements/About";
import Contract from "./elements/Contract";
import error404 from "./elements/error404";
import MediaGallery from "./elements/MediaGallery";
import Reward from "./elements/Reward";
import Education from "./elements/Education";
import PastActivities from "./elements/PastActivities";


import { BrowserRouter, Switch, Route } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';

class Root extends Component {
    render() {
        return (
            <BrowserRouter basename={'/'}>
                <PageScrollTop>
                    <Switch>
                        <Route exact path={`${process.env.PUBLIC_URL}/`} component={Home} />
                        {/* Element Layot */}
                        <Route exact path={`${process.env.PUBLIC_URL}/contract`} component={Contract} />
                        <Route exact path={`${process.env.PUBLIC_URL}/about`} component={About} />
                        <Route exact path={`${process.env.PUBLIC_URL}/media`} component={MediaGallery} />
                        <Route exact path={`${process.env.PUBLIC_URL}/reward`} component={Reward} />
                        <Route exact path={`${process.env.PUBLIC_URL}/education`} component={Education} />
                        <Route exact path={`${process.env.PUBLIC_URL}/past-activities`} component={PastActivities} />
                        <Route path={`${process.env.PUBLIC_URL}/404`} component={error404} />
                        <Route component={error404} />

                    </Switch>
                </PageScrollTop>
            </BrowserRouter>
        )
    }
}

ReactDOM.render(<Root />, document.getElementById('root'));
serviceWorker.register();
